module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/OtherModules.component.html
// module id = ./src/app/OtherModules.component.html
// module chunks = main